import React from 'react';

import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';

import s from './Quote.module.scss';
import cx from 'classnames';

type Props = {
  content?: string;
  citation?: string;
};

export const Quote = (props: Props) => {
  const { content, citation } = props;

  if (!content) {
    return null;
  }

  return (
    <div className={s.quote}>
      <GridLayout className={s.background}>
        <GridLayoutItem
          className={s.quote__contentWrap}
          offset={{ desktop: 1, mobile: 1 }}
          columns={{ desktop: 10, mobile: 10 }}
        >
          <p
            className={cx(s.quote__content, {
              [s.hasCitation]: !!citation,
            })}
          >
            {content}
          </p>
          {citation && <div className={s.quote__citation}>— {citation}</div>}
        </GridLayoutItem>
      </GridLayout>
    </div>
  );
};
